import { CommonBG } from '@riddler-co-jp/specc-ui-components';
import * as React from 'react';
import styled from 'styled-components';

import Create3Answer from './Create3Answer';

interface Stage2Props {
  stage: number;
}

const Create3Game: React.FC<Stage2Props> = props => {
  return (
    <CommonBG>
      <MainWrapper>
        <Create3Answer turn={props.stage - 1} />
      </MainWrapper>
    </CommonBG>
  );
};

const MainWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 4rem);
  margin: 4rem auto 0;
  display: flex;
  overflow: hidden;
  overflow-y: scroll;
`;

export default Create3Game;
